import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environments';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { ICustomEopSection, IEopSection } from '../models/eopSection';

@Injectable({
    providedIn: 'root'
})
export class EopSectionService {

    private buildingBasicPlan: IEopSection[] = [];
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getEopSectionsByBuildingId(buildingId: any): Observable<{message: string; data: IEopSection[]}> {
        let url = environment.apiBaseUrl + endpoints.eopSectionsByBuildingId.replace(':buildingId', buildingId);
        return this.http.get<{message: string; data: IEopSection[]}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    verifyIfSectionExistsOnnBuilding(buildingId: string, sectionType: number): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.verifyIfSectionExistsOnBuilding.replace(':buildingId', buildingId).replace(':sectionType', sectionType.toString());
        return this.http.get<{has_error: boolean, message: string, data: any}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateBasicPlan(buildingId: string, eopSections: number[]): Observable<{has_error: boolean, message: string}> {
        const url = environment.apiBaseUrl + endpoints.createBasicPlanForBuilding.replace(':buildingId', buildingId);
        return this.http.post<{has_error: boolean, message: string}>(url, eopSections).pipe(
            catchError(this.errorService.handleError)
        );
    }
}